import { Autocomplete, TextField, createFilterOptions } from "@mui/material";
import { useNavigate } from "react-router";
import { PATH_DASHBOARD } from "routes/paths";

type Props = {
  setSelectedColourPalette: (colourPalleteId: string) => void;
  colourPaletteOptions: Array<Record<string, string>>;
  defaultValue?: Record<string, string>;
};

export default function ColourPaletteAutoComplete({
    setSelectedColourPalette,
    colourPaletteOptions,
    defaultValue,
}: Props) {
  const navigate = useNavigate();
  const filter = createFilterOptions<Record<string, string>>();

  return (
    <Autocomplete
      id="colourPaletteAutoComplete"
      options={Object.values(colourPaletteOptions)}
      defaultValue={defaultValue}
      getOptionLabel={(option) => option?.id}
      renderOption={(props, option) => (
        <li {...props}>
          {option?.title} {option?.id}
        </li>
      )}
      onChange={(_, value) => {
        if (!value) {
          return;
        }

        setSelectedColourPalette(value?.id);

        navigate(`${PATH_DASHBOARD.contentColourPalettes.root}/${value?.id}`);
      }}
      sx={{ width: 300 }}
      renderInput={(params) => (
        <TextField {...params} label="Search for Colour Palettes by ID" />
      )}
      filterOptions={(options, params) => {
        const filtered = filter(options, params);

        if (params?.inputValue !== "") {
          filtered.push({
            id: params?.inputValue,
            title: `Add "${params?.inputValue}"`,
          });
        }

        return filtered;
      }}
    />
  );
}
